import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paragraph, Subtitle } from '@components/Styled';
import { Notification as NotificationContainer } from '../NotificationCenter.style';
const DATE_OPTIONS = { month: 'long', day: 'numeric' };
const HOUR_OPTIONS = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'America/Mexico_City'
};
const AutomaticRentReleaseWithoutInvoiceFailed = (props) => {
    const { notification } = props;
    const releaseRentDate = new Date(notification.params?.releaseRentDate);
    const formattedDate = releaseRentDate.toLocaleDateString('es-MX', DATE_OPTIONS);
    const formattedHour = releaseRentDate.toLocaleTimeString('es-MX', HOUR_OPTIONS);
    return (_jsxs(NotificationContainer, { children: [_jsx(Subtitle, { level: "3", children: "No pudimos liberar tus ingresos" }), _jsxs(Paragraph, { children: ["El intento realizado el", ` ${formattedDate} `, "a las", ` ${formattedHour} h `, "no se complet\u00F3. Tus ingresos contin\u00FAan pendientes de liberaci\u00F3n."] }), _jsx(Paragraph, { color: "grayF", children: notification.getLocaleDate() })] }));
};
export default AutomaticRentReleaseWithoutInvoiceFailed;
